import { CompletedByHustlersResponse } from '../dao/core-dao'
import { coreService } from '../service/core-service'
import { queryKeys } from '../util/query-keys'
import { UseInfiniteQueryResult, useInfiniteQuery } from '@tanstack/react-query'

export const useCompletedByHustlers = (workoutId: string): UseInfiniteQueryResult<CompletedByHustlersResponse, Error> => {
  return useInfiniteQuery<CompletedByHustlersResponse, Error>({
    queryKey: queryKeys.workoutCompletedBy(workoutId, 0),
    queryFn: ({ pageParam = 1 }) =>
      coreService.getWorkoutCompletedByHustlers({
        workoutId,
        page: pageParam,
        pageSize: 20,
        includeMetrics: true,
        includeCompletedAt: true,
        includeCompletedWorkoutCount: true,
      }),
    getNextPageParam: (lastPage) => {
      if (lastPage.page >= lastPage.totalPages) return undefined
      return lastPage.page + 1
    },
    enabled: !!workoutId,
  }) as UseInfiniteQueryResult<CompletedByHustlersResponse, Error>
}
